import React, { ReactElement } from 'react';
import { Label, MultiChoice } from 'idsk-react-components';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import getLabel from '../function/getLabel';

interface Props {
  stav: MultiChoiceItem[],
  setStav: (stav: MultiChoiceItem[]) => void,
}
const VyhodnotenieMultichoice = ({ stav, setStav }:Props):ReactElement => (
  <>
    <Label htmlFor="Vyhodnotenie">Vyhodnotenie</Label>
    <MultiChoice
      id="multi-choice-stav"
      data={stav}
      onChange={(newData) => {
        setStav(newData);
      }}
      label={(size) => getLabel(size, stav)}
    />
  </>
);

export default VyhodnotenieMultichoice;
